/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useLocation, useNavigate, Location } from "react-router-dom";
import { Button, theme } from "@nordcloud/gnui";
import { DiscoveryRule } from "~/generated/graphql";
import { DiscoveryRulesForm } from "~/components";
import { SUCCESS_TEXT } from "~/constants";
import { useDiscoveryRules } from "~/hooks";
import { showError, showSuccess } from "~/services/toast";
import { isNotEmpty } from "~/tools";

type LocationState = {
  showDiscoveryRules?: boolean;
};

type Props = {
  envId: string;
};

export function EnvironmentDiscoveryRules({ envId }: Props) {
  const [showForm, setShowForm] = React.useState(false);

  const location: Location<LocationState> = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (location.state?.showDiscoveryRules) {
      setShowForm(true);
      navigate(location.pathname, { state: {}, replace: true });
    }
  }, [location, navigate]);

  const { loading, error, rules, update } = useDiscoveryRules({
    envId,
    onSuccess: () => {
      showSuccess(SUCCESS_TEXT.discoveryRulesChanged);
    },
  });

  const handleSubmit = (newRules: DiscoveryRule[]) => {
    // setShowForm(false);
    update(newRules);
  };

  React.useEffect(() => {
    if (isNotEmpty(error)) {
      showError(error);
    }
  }, [error]);

  return (
    <div
      css={{
        marginRight: theme.spacing.spacing04,
      }}
    >
      <Button
        icon="settings"
        disabled={loading}
        initialState={loading ? "loading" : ""}
        onClick={() => setShowForm(true)}
      >
        Discovery Rules
      </Button>
      <DiscoveryRulesForm
        isOpen={showForm}
        rules={rules}
        onSubmit={handleSubmit}
        onClose={() => setShowForm(false)}
      />
    </div>
  );
}
